export const toCamelCase = str => {
  const words = str?.split(' ')
  const camelCaseWords = words?.map(word => {
    return word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase()
  })
  return camelCaseWords?.join(' ')
}

export const renderTitle = selections => {
  const selected = Object.keys(selections)
    .filter(key => selections[key] && selections[key].length > 0)
    .map(key => key)

  if (selected.length === 0) return 'No selection made'
  if (selected.length === 1) return `${selected[0]} wise`

  const last = selected.pop()
  return selected.length > 0
    ? `${selected.join(', ')} and ${last} wise`
    : `${last} wise`
}

export const getOptOutType = type => {
  switch (type) {
    case 'FAMILYBUSINESS':
      return 'Family Business'
    case 'HIGHEREDUCATION':
      return 'Higher Education'
    case 'ENTREPRENEUR':
      return 'Entrepreneur'
    default:
      return '-'
  }
}
